import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';
import shortid from 'shortid';

import Translatable from '../../../../../../../components/Translatable';
import Filter from '../../../Filter';

import styles from './styles.js';

import { createFiltersQueryStringFromObject } from '../../../../../../../methods';

import { isAllDaySelected } from '../../../../../selectors';

class PanelSmall extends Component {
    static propTypes = {
        allDaySelected: PropTypes.bool.isRequired,
        apiUrl: PropTypes.string.isRequired,
        applyFilterGroupCollection: PropTypes.func.isRequired,
        changeButtonText: PropTypes.func,
        currencySymbol: PropTypes.string.isRequired,
        fetchSearchResults: PropTypes.func.isRequired,
        filterGroupCollection: PropTypes.object.isRequired,
        filterGroupCollectionIndex: PropTypes.number.isRequired,
        handleActiveFilterGroupCollection: PropTypes.func.isRequired,
        lang: PropTypes.object.isRequired,
        searchParams: PropTypes.object.isRequired,
        trackingCookieId: PropTypes.number.isRequired,
        updateFilterGroupCollection: PropTypes.func.isRequired,
        userLang: PropTypes.string.isRequired
    }

    state = {
        allDay: this.props.allDaySelected,
        filterGroupCollection: this.props.filterGroupCollection,
        hasChanged: false,
        isCancelled: false
    }

    componentWillUnmount() {
        const { applyFilterGroup } = this;
        applyFilterGroup();
    }

    addUpdatedFilterToState = (filterGroupIndex, filterIndex, updatedFilter, buttonText) => {
        const { filterGroupCollection } = this.state;
        const filters = filterGroupCollection.filterGroups[filterGroupIndex].filters.map(
            (filter, index) => {
                if (Number(index) !== Number(filterIndex)) {
                    return filter;
                }
                return {
                    ...filter,
                    ...updatedFilter
                };
            }
        );
        const filterGroups = filterGroupCollection.filterGroups.map((filterGroup, index) => {
            if (Number(index) !== Number(filterGroupIndex)) {
                return filterGroup;
            }
            return {
                ...filterGroup,
                filters
            };
        });
        const updatedFilterGroupCollection = {
            ...filterGroupCollection,
            buttonText,
            filterGroups
        };
        this.setState({ filterGroupCollection: updatedFilterGroupCollection });
    }

    applyFilterGroup = () => {
        const { filterGroupCollection, hasChanged, isCancelled } = this.state;
        const {
            apiUrl,
            applyFilterGroupCollection,
            fetchSearchResults,
            filterGroupCollectionIndex,
            searchParams,
            trackingCookieId,
            userLang
        } = this.props;
        if (!isCancelled && hasChanged) {
            applyFilterGroupCollection(filterGroupCollection, filterGroupCollectionIndex);
            const location = decodeURIComponent(window.location.pathname.split('/')[4]);
            const tag = {
                quick_slug: decodeURIComponent(window.location.pathname.split('/')[3])
            };
            const paramsQs = createFiltersQueryStringFromObject(searchParams, filterGroupCollection);
            fetchSearchResults(apiUrl, userLang, location, tag, paramsQs, trackingCookieId);
        }
    }

    handleApplyFilters = () => {
        const { filterGroupCollection } = this.state;
        const {
            filterGroupCollectionIndex,
            handleActiveFilterGroupCollection,
            updateFilterGroupCollection
        } = this.props;
        updateFilterGroupCollection(filterGroupCollectionIndex, filterGroupCollection);
        handleActiveFilterGroupCollection(filterGroupCollectionIndex);
    }

    handleCancelFilters = () => {
        const { filterGroupCollectionIndex, handleActiveFilterGroupCollection } = this.props;
        this.setState({
            isCancelled: true
        }, () => {
            handleActiveFilterGroupCollection(filterGroupCollectionIndex);
        });
    }

    handleFilterChange = event => {
        const { addUpdatedFilterToState } = this;
        const { filterGroupCollection } = this.state;
        const filterIndex = event.target.dataset.filterIndex;
        const filterGroupIndex = event.target.dataset.filterGroupIndex;
        const inputType = event.target.dataset.inputType;
        let value;
        if (inputType === 'checkbox') {
            value = event.target.checked;
        } else if (inputType === 'radio') {
            value = event.target.checked;
        } else if (inputType === 'increment') {
            value = Number(event.target.dataset.value);
        } else if (inputType === 'toggle-switch') {
            value = event.target.checked;
            if (filterGroupCollection.filterGroups[filterGroupIndex].slug === 'all-day') {
                this.setState(prevState => {
                    return ({ allDay: !prevState.allDay });
                });
            }
        } else if (inputType === 'dropdown') {
            value = Number(event.target.value);
        } else {
            value = event.target.value;
        }
        const updatedFilter = {
            ...filterGroupCollection.filterGroups[filterGroupIndex].filters[filterIndex],
            data: {
                ...filterGroupCollection.filterGroups[filterGroupIndex].filters[filterIndex].data,
                value
            }
        };
        this.setState({
            hasChanged: true
        });
        addUpdatedFilterToState(filterGroupIndex, filterIndex, updatedFilter, filterGroupCollection.buttonText);
    }

    handleSliderChange = (filterGroupIndex, filterIndex, valueArr) => {
        const { addUpdatedFilterToState } = this;
        const { filterGroupCollection } = this.state;
        const { currencySymbol } = this.props;
        const updatedValues = [
            {
                slug: 'max_price',
                value: Number(valueArr[1])
            },
            {
                slug: 'min_price',
                value: Number(valueArr[0])
            }
        ];
        const updatedFilter = {
            ...filterGroupCollection.filterGroups[filterGroupIndex].filters[filterIndex],
            data: {
                ...filterGroupCollection.filterGroups[filterGroupIndex].filters[filterIndex].data,
                values: updatedValues
            }
        };
        const buttonText = `${currencySymbol}${valueArr[0]} - ${currencySymbol}${valueArr[1]}`;
        this.setState({
            hasChanged: true
        });
        addUpdatedFilterToState(filterGroupIndex, filterIndex, updatedFilter, buttonText);
    }

    render() {
        const {
            handleApplyFilters,
            handleCancelFilters,
            handleFilterChange,
            handleSliderChange
        } = this;
        const { filterGroupCollection } = this.state;
        const {
            changeButtonText,
            filterGroupCollectionIndex,
            lang
        } = this.props;
        const { allDay } = this.state;
        const { filterGroups } = filterGroupCollection;
        return (
            <div className={css(styles.panelSmall)}>
                <div className={css(styles.panelContentContainer)}>
                    {filterGroups.map((filterGroup, filterGroupIndex) => {
                        if (filterGroup) {
                            return (
                                <div
                                    key={shortid.generate()}
                                    className="row"
                                    style={{
                                        marginBottom: '15px'
                                    }}
                                >
                                    {filterGroup.filters.map((filter, filterIndex) => (
                                        <Filter
                                            key={shortid.generate()}
                                            changeButtonText={changeButtonText}
                                            columns={filterGroup.columns}
                                            filter={filter}
                                            filterIndex={filterIndex}
                                            filterGroup={filterGroup}
                                            filterGroupIndex={filterGroupIndex}
                                            filterGroupCollectionIndex={filterGroupCollectionIndex}
                                            handleFilterChange={handleFilterChange}
                                            handleSliderChange={handleSliderChange}
                                            isDisabled={
                                                ((filterGroup.slug === 'duration' ||
                                                filterGroup.slug === 'time') && allDay) ?
                                                    true : false
                                            }
                                            lang={lang}
                                        />
                                    ))}
                                </div>
                            );
                        }
                    })}
                </div>
                <div className={css(styles.panelActionsContainer)}>
                    <a
                        className={css(styles.panelActionLink)}
                        onClick={handleCancelFilters}
                    >
                        <Translatable
                            content={{
                                transKey: 'common.cancel'
                            }}
                        />
                    </a>
                    <span className={css(styles.pullRight)}>
                        <a
                            className={css(styles.panelActionLink)}
                            onClick={handleApplyFilters}
                        >
                            <Translatable
                                content={{
                                    transKey: 'common.apply'
                                }}
                            />
                        </a>
                    </span>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    allDaySelected: isAllDaySelected(state),
    lang: state.lang,
    searchParams: state.searchParams,
    userLang: state.config.userLang
});

export default connect(mapStateToProps)(PanelSmall);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Panels/PanelSmall/PanelSmall.jsx